import { render, staticRenderFns } from "./maxminvalue.vue?vue&type=template&id=2a2b5005&"
import script from "./maxminvalue.vue?vue&type=script&lang=ts&"
export * from "./maxminvalue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "maxminvalue.vue"
export default component.exports